function collectRequired(node, result = new Set()) {
  if (!node || typeof node !== 'object') {
    return result
  }
  if (Array.isArray(node.required)) {
    node.required.forEach((f) => result.add(f))
  }
  for (const key of ['allOf', 'anyOf', 'oneOf']) {
    if (Array.isArray(node[key])) {
      node[key].forEach((s) => collectRequired(s, result))
    }
  }
  for (const key of ['then', 'else']) {
    if (node[key]) {
      collectRequired(node[key], result)
    }
  }
  return result
}

export function isFieldRequired(schema, scope) {
  const parts = scope.replace(/^#\//, '').split('/')
  const fieldName = parts[parts.length - 1]
  let node = schema
  for (const key of parts.slice(0, -2)) {
    node = node?.[key]
  }
  return collectRequired(node).has(fieldName)
}
